import React from "react";
import GraphSmsDashboard from "./GraphSmsDashboard";
import CardsDashboard from "./CardsDashboard";
import ProcessingMessages from "./ProcessingMessages";
import CarrierMessages from "./CarrierMessages";
import PieChartSmsDashboard from "./PieChartSmsDashboard";
import { useAuth } from "../../../Context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
import Icon from "../../Icon";
import SummaryMessagesByPartner from "./SummaryMessagesByPartner";
import HealthApi from "./HealthApi";
import ErrorCard from "./ErrorCard";

const _SmsDashboard = () => {
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const {
    isPending,
    data: dataCards,
    refetch: refetchCards,
  } = useQuery({
    queryKey: ["smsDashboard"],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}dashboard/messagesmry`,
        {},
        token,
      );

      const [res = {}] = await response.data;
      return res;
    },
    refetchOnWindowFocus: false,
  });

  const {
    isPending: loadingGraph,
    data: dataGraph,
    refetch: refetchGraph,
  } = useQuery({
    queryKey: ["smsDashboardGraph"],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}dashboard/messagesmrybyhour`,
        {},
        token,
      );

      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  const {
    isPending: loadingProcessingMessages,
    data: dataProcessingMessages,
    refetch: refetchProcessingMessages,
  } = useQuery({
    queryKey: ["smsDashboardProcessingMessages"],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}dashboard/messagespending`,
        {},
        token,
      );
      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  const {
    isPending: loadingCarrierMessages,
    data: dataCarrierMessages,
    refetch: refetchCarrierMessages,
    isRefetching: refetchingCarrierMessages,
  } = useQuery({
    queryKey: ["smsDashboardCarrierMessages"],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}dashboard/messagescarrier`,
        {},
        token,
      );

      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  const {
    data: messagesmrybypartner,
    refetch: refetchMessagesmrybypartner,
    isPending: loadingMessagesmrybypartner,
    isRefetching: refetchingMessagesmrybypartner,
  } = useQuery({
    queryKey: ["messagesmrybypartner"],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}dashboard/messagesmrybypartner`,
        {},
        token,
      );
      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  const {
    data: requestsApiSmry,
    refetch: refetchRequestsApiSmry,
    isPending: loadingrequestsApiSmry,
    isRefetching: refetchingrequestsApiSmry,
  } = useQuery({
    queryKey: ["requestsapismry"],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}dashboard/requestsapismry`,
        {},
        token,
      );

      const [res = {}] = await response.data;
      return res;
    },
    refetchOnWindowFocus: false,
  });

  const refetchAll = async () => {
    try {
      await Promise.all([
        refetchCards(),
        refetchGraph(),
        refetchProcessingMessages(),
        refetchCarrierMessages(),
        refetchMessagesmrybypartner(),
        refetchRequestsApiSmry(),
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex justify-end">
        <button
          className="flex items-center text-gray-600 bg-gray-200 px-2 py-1.5 rounded hover:bg-gray-300 border-none disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={refetchAll}
          disabled={isPending}
        >
          <Icon icon="refresh" size={20} />
          <span className="ml-2 text-[12px]">Actualizar</span>
        </button>
      </div>
      <div className="grid auto-rows-auto grid-cols-1 md:grid-cols-5 gap-2">
        <CardsDashboard
          data={dataCards}
          loading={isPending || refetchingCarrierMessages}
        />
        <ErrorCard
          data={dataCards}
          loading={isPending || refetchingCarrierMessages}
        />
        <HealthApi
          data={requestsApiSmry}
          loading={loadingrequestsApiSmry || refetchingrequestsApiSmry}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-1 md:col-span-1 lg:col-span-3 space-y-2">
          <PieChartSmsDashboard
            data={dataCards}
            loading={isPending || refetchingCarrierMessages}
          />
        </div>

        <div className="col-span-1 md:col-span-2 lg:col-span-9">
          <GraphSmsDashboard
            data={dataGraph}
            loading={loadingGraph || refetchingCarrierMessages}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <ProcessingMessages
          data={dataProcessingMessages}
          loading={loadingProcessingMessages || refetchingCarrierMessages}
        />

        <CarrierMessages
          data={dataCarrierMessages}
          loading={loadingCarrierMessages || refetchingCarrierMessages}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-2">
        <SummaryMessagesByPartner
          data={messagesmrybypartner}
          loading={
            loadingMessagesmrybypartner || refetchingMessagesmrybypartner
          }
        />
      </div>
    </div>
  );
};

export default _SmsDashboard;
